module.exports = __webpack_public_path__ + "media/s1_v1.ed338052.mp4";